import * as React from 'react';

import { IBaseQuestionProps } from '../../FormContainer/types/internal';
import { EQuestionCode } from '../../../types/form';

export const useSubmitBtnText = (props: IBaseQuestionProps) => {
  const {
    question: { code },
  } = props;

  return React.useMemo(() => {
    if (code === EQuestionCode.PhoneVerify) {
      return 'Подтвердить номер и отправить заявку';
    }

    return 'Отправить заявку';
  }, [code]);
};
